<template>
  <b-form-group :label="label" :label-for="inputId" :description="description">
    <div v-if="isLoading" class="d-flex align-items-center mb-2">
      <b-spinner small type="grow" label="Carregando..." />
      <span class="ml-2">Carregando cidades...</span>
    </div>
    <b-form-select
      :id="inputId"
      v-model="internalValue"
      :options="cityOptions"
      :required="required"
      :state="isValid"
      :disabled="!selectedState"
      @change="handleChange"
      @blur="handleBlur"
    >
      <option disabled value="">Selecione...</option>
    </b-form-select>
    <b-form-invalid-feedback :id="`${inputId}-feedback`">
      {{ invalidFeedback }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  name: 'CitySelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    selectedState: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '*Cidade',
    },
    inputId: {
      type: String,
      default: 'city-select-input',
    },
    description: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
    invalidFeedback: {
      type: String,
      default: 'Por favor, selecione uma cidade.',
    },
    validationFunc: {
      type: Function,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value,
      isValid: this.state,
      cityOptions: [{ value: '', text: 'Selecione...' }],
      isLoading: false,
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
      this.validate();
    },
    selectedState(newVal) {
      this.value = '';
      this.cityOptions = [{ value: '', text: 'Selecione...' }];
      this.fetchCities(newVal);
    },
    state(newVal) {
      this.isValid = newVal;
    },
  },
  mounted() {
    if (this.selectedState) {
      this.fetchCities(this.selectedState);
    }
  },
  methods: {
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    handleChange() {
      this.$emit('input', this.internalValue);
      this.validate();
    },
    handleBlur() {
      this.validate();
    },
    validate() {
      if (!this.validationFunc) {
        this.isValid = this.required ? !!this.internalValue : null;
      } else {
        this.isValid = this.validationFunc(this.internalValue);
      }
      this.$emit('validation-updated', this.isValid);
    },

    async fetchCities(stateCode) {
      if (!stateCode) {
        this.cityOptions = [{ value: '', text: 'Selecione...' }];
        this.value = '';
        return;
      }

      const cachedData = localStorage.getItem(`cities_${stateCode}`);
      if (cachedData) {
        const parsed = JSON.parse(cachedData);
        this.cityOptions = parsed;
        if (!parsed.find(opt => opt.value === this.internalValue)) {
          this.value = '';
        }
        return;
      }

      let newList = [{ value: '', text: 'Selecione...' }];
      this.isLoading = true;
      try {
        const { model, ok, errors } = await API.post('/execute', {
          path: '/lead-management/municipios-por-estado',
          method: 'get',
          data: {
            stateAcronym: stateCode,
          },
        });

        if (!ok) {
          this.showToast(errors.message, 'Erro', 'danger');
          return;
        }

        if (!model || !model.length) {
          this.showToast('Nenhuma cidade encontrado.', 'Aviso', 'warning');
          return;
        }

        newList = model.map(city => ({
          value: city.code,
          text: `${city.code} - ${city.description}`,
        }));
        this.cityOptions = newList;
        localStorage.setItem(`cities_${stateCode}`, JSON.stringify(newList));
        if (!newList.find(opt => opt.value === this.internalValue)) {
          this.value = '';
        }
      } catch (error) {
        this.showToast('Erro ao buscar cidades', 'Erro', 'danger');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
